import { webApi } from '@mi-front/api-clients';
import { useFragmentGridContext } from '../../fragments-grid/FragmentGridContext';
import { FragmentCardBase } from '../base/FragmentCardBase';
import { AudioFragmentCardList } from './AudioFragmentCardList';
import { AudioFragmentMedia } from './AudioFragmentMedia';

/**
 * Card for an audio fragment: no media/poster, no social upload icons.
 * Shows waveform with time/duration pill overlay, title in content, plus footer with creator and relative time.
 * Renders list layout when viewMode is 'list', grid layout otherwise.
 */
export function AudioFragmentCard({ fragment }: { fragment: webApi.FragmentListItemDto }) {
  const { viewMode } = useFragmentGridContext();

  if (viewMode === 'list') {
    return <AudioFragmentCardList fragment={fragment} />;
  }

  return (
    <FragmentCardBase fragment={fragment} media={<AudioFragmentMedia fragment={fragment} />} />
  );
}
